// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rm-EV","buttons":"styles_buttons__1b4Vs"};